<template>
  <div>
    Cases list page
    <re-calculate-all-cases-anomalies-form/>
    <update-all-case-services-info-form/>
  </div>
</template>

<script>
  import ReCalculateAllCasesAnomaliesForm from "../../components/case-anomalies/ReCalculateAllCasesAnomaliesForm";
  import UpdateAllCaseServicesInfoForm from '../../components/analytics/UpdateAllCaseServicesInfoForm'

  export default {
    name: 'cases-page',
    components: {
      ReCalculateAllCasesAnomaliesForm,
      UpdateAllCaseServicesInfoForm
    },
    props: {},
    data() {
      return {}
    },
    computed: {},
    mounted() {

    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/cases/CasesIndexPage.vue